import React from "react";

const ExplanationsRight = () => {
  return (
    <div className="text-block">
      <h4>
        <strong>Пояснения к графикам</strong>
      </h4>
      <p>
        <a href="#analyticsСharts" className="anchor-link">
          <strong>1. График «Анализ эффективности вложений от площади»</strong>
        </a>
        <br />
        На графике сравнивается возможная эффективность вложений с{" "}
        <strong>эталонной ставкой для сравнения</strong> на основе введенных
        данных (арендная ставка и параметры привлекаемого кредита). Это помогает
        определить наиболее выгодные площади при выборе помещений.
      </p>
      <p>
        <a href="#analyticsСharts" className="anchor-link">
          <strong>
            2. График «Анализ эффективности вложений от арендной ставки»
          </strong>
        </a>
        <br />
        График демонстрирует сравнение возможной эффективности вложений с{" "}
        <strong>эталонной ставкой для сравнения</strong> при заданных значениях
        (площадь и условия привлекаемого кредита). Позволяет оценить допустимые
        уровни арендной ставки, если помещение планируется брать в аренду.
      </p>
      <p>
        <a href="#analyticsСharts" className="anchor-link">
          <strong>
            3. График «Анализ вариантов налогообложения УСН от площади»
          </strong>
        </a>
        <br />
        На графике сравниваются два варианта УСН (упрощенной системы
        налогообложения) для разных площадей с учетом введенных данных (арендная
        ставка и параметры кредита). Результаты помогают выбрать оптимальный
        налоговый режим.
      </p>
      <p>
        <a href="#analyticsСharts" className="anchor-link">
          <strong>4. Анализ окупаемости проекта</strong>
        </a>
        <br />
        График отображает расчетные сроки простой и дисконтированной окупаемости
        проекта на основе введенных данных.
        <br />
        Методика расчета:
        <br />- Ставка дисконтирования рассчитана как{" "}
        <strong>эталонная ставка для сравнения</strong>
        <br />- Учтены все введенные финансовые параметры проекта
      </p>
      <p>
        <a href="#lastElem" className="anchor-link">
          <strong>5. Сравнение продаж по картам</strong>
        </a>
        <br />
        График демонстрирует динамику продаж фитнес-карт по годам.
        <br />
        Данные для сравнения:
        <br />
        - Фактические продажи сети AGYM за 2023–2025 годы (14 клубов, площадь
        1100–2500 м²)
        <br />
        - Прогнозные продажи по 7-летней модели развития
        <br />
        Визуализация позволяет оценить соответствие прогноза реальным
        показателям и перспективы роста. <br />
        Данные усреднены и приведены для справки.
      </p>
    </div>
  );
};

export default ExplanationsRight;
